__turbopack_context__.v({
  "className": "allura_a790634e-module__F5wQCq__className",
  "variable": "allura_a790634e-module__F5wQCq__variable",
});
